import React from "react";
import { ListViewProvider, ListViewProviderProps } from "./Provider";
import "./style.css";

export const ListView: React.FC<ListViewProviderProps> = (
  listViewProviderProps
) => {
  return <ListViewProvider {...listViewProviderProps} />;
};
